<template>
	<div class="row">
		<div class="col-sm-6">
			<div class="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate">
				<ul class="pagination f_left">
					<li class="paginate_button previous" aria-controls="DataTables_Table_0" tabindex="0" id="DataTables_Table_0_previous">
		                <a href="javascript:void(0)" aria-label="Previous" @click="firstPage">
		                    <span aria-hidden="true">&laquo;</span>
		                </a>
		            </li>
					<li class="paginate_button previous" aria-controls="DataTables_Table_0" tabindex="0" id="DataTables_Table_0_previous">
						<a href="javascript:void(0)" @click="prePage">‹</a>
					</li>
					<li class="paginate_button" aria-controls="DataTables_Table_0" tabindex="0" v-for="(page,index) in pages" >
						<a href="javascript:void(0)" @click="relatedPage(page)" :class="{active:activeNum === page}">{{page}}</a>
					</li>
					<li class="paginate_button next" aria-controls="DataTables_Table_0" tabindex="0" id="DataTables_Table_0_next">
						<a href="javascript:void(0)" @click="nextPage">›</a>
					</li>
					<li class="paginate_button next" aria-controls="DataTables_Table_0" tabindex="0" id="DataTables_Table_0_previous">
		                <a href="javascript:void(0)" aria-label="Next" @click="lastPage">
		                    <span aria-hidden="true">&raquo;</span>
		                </a>
		           </li>
				</ul>
				<span class="pagination t_right" style="line-height:28px; padding:0 10px;">第
						<input type="text" v-model="pageSel" @change="selPage" style="display:inline-block;width:50px;height:28px;text-align: center;border:1px solid #ccc;" />
					页</span>
				<span class="pagination" style="line-height:28px;">共{{pageInfo.total}}条</span>
				
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Pagination',
		data() {
			return {	
				pageLen: 5,		//默认显示页数
				pages:[],		//当前显示的页码数数组
				activeNum:1,	//选中的页码数-当前页
				pageSel:1,
				preClickTag:0,
				nextClickTag:0
			}
		},
		props: {
			pageInfo:{
				type:Object,
				default:function(){
					return {}
				}
			}
		},
		mounted() {			
			this.initPagesInfo()
		},
		watch: {
			pageInfo:{
	    		handler(newValue, oldValue) {
	    			if (oldValue.pageNum!==newValue.pageNum){
	    				this.activeNum = newValue.pageNum  
	    			}
	    			if (oldValue.pages!==newValue.pages||newValue.isFirstPage){
	    				this.initPagesInfo();
	    				this.activeNum = 1     
	    			}
	　　　　		},
				deep:true
	    	},
			'activeNum' (newVal, oldVal) {
				this.getData()
				this.pageSel = newVal;
			},
		},
		methods: {
			//跳转到第一页
			firstPage(){
				if (this.pages[0] === 1) {
	                this.activeNum = 1	              
	            } else {
	                this.initPagesInfo();
	                this.activeNum = 1     
	            }	         
			},
			//跳转到最后一页
			lastPage(){
				if (this.pageInfo.pages <= this.pageLen) {
	                this.activeNum = this.pages.length
	            } else {
	                let lastPage = []
	                for (let i = this.pageLen - 1; i >= 0; i--) {
	                    lastPage.push(this.pageInfo.pages - i)
	                }
	                this.pages = lastPage
	                this.activeNum = this.pageInfo.pages
	            }
			},
			prePage() {//上一页
				// 当前页是否为当前最小页码
				if (this.preClickTag==0){
					this.preClickTag = 1;  
					
					if (this.activeNum!==1) {
						if (this.pages.includes(this.activeNum - 1)){
							this.activeNum = this.activeNum - 1
						}else{
							this.activeNum = this.activeNum - 1
							this.pages.pop();
							this.pages.unshift(this.activeNum);
						}
					}
					let that = this;
					setTimeout(function () { that.preClickTag = 0 }, 1000);  
				}
			},
			nextPage() {//下一页
				// 当前页是否为当前最大页码
				if (this.nextClickTag==0){
					this.nextClickTag=1;
					
					if (this.activeNum!==this.pageInfo.pages) {
						if (this.pages.includes(this.activeNum + 1)){
							this.activeNum = this.activeNum + 1
						}else{
							this.activeNum = this.activeNum + 1
							this.pages.push(this.activeNum);
							this.pages.shift(this.activeNum);
						}
					}
					let that = this;
					setTimeout(function () { that.nextClickTag = 0 }, 1000);  
				}
			},
			relatedPage(page) {//当前页
				this.activeNum = page		
			},
			selPage(){  
				let pageSel = parseInt(this.pageSel)
				if(pageSel > this.pageInfo.pages || this.pageSel < 1){
					return;
				}
				this.activeNum = this.pageSel;
				if (this.pageInfo.pages > this.pageLen) {
	                let curPages = []
	                curPages[0] = pageSel;
	                for(let i = 1, len = this.pageLen; i < len; i ++){
	                	if(pageSel + i <= this.pageInfo.pages){
	                		curPages.push(pageSel + i)
	                	} 
	                } 
	                this.pages = curPages  
	            }
			},
			//获取当前显示页码的数组，pages:页码数组成的数组
			initPagesInfo() {
				// 比较总页码和默认显示页数  
				this.pages=[];
				if(this.pageInfo.pages <= this.pageLen) {
					for(let i = 1; i <= this.pageInfo.pages; i++) {
						this.pages.push(i)
					}
				} else {
					for(let i = 1; i <= this.pageLen; i++) {
						this.pages.push(i)
					}
				}
			},
			getData() {
				this.$emit('getData', this.activeNum)
			}
		}
	}
</script>

<style scoped lang="scss">
	
	
	a.active {
		background-color: #eee;
	}
</style>


// WEBPACK FOOTER //
// Pagination.vue?0e3aa2e7